import { storageGet, storageSet } from './storage';

/**
 * Forms PDF layout settings — how submission / collection PDFs are laid out and
 * branded; applied at generation time by utils/formPdf.js and utils/reportPdf.js.
 *
 * Stored in THIS BROWSER only (per signed-in user, via utils/storage), not on the
 * server — so they don't follow you to another device or apply to colleagues.
 * Screens that edit them must say so. The company logo and name come from the
 * server-side company profile, not from here.
 */
const KEY = 'form_pdf_settings';
const LEGACY_KEY = 'cw_form_pdf_settings';

export const FORM_PDF_DEFAULTS = {
  coverPage: true,        // collection PDFs get a summary cover page
  includeLogo: true,      // stamp the company logo (from Company & Branding)
  accent: '#1A80E5',      // table header / accent colour
  headerText: '',         // optional line under the title
  footerText: '',         // optional footer (falls back to a generated-on line)
};

/** True: these settings live only in this browser. */
export const FORM_PDF_SETTINGS_LOCAL_ONLY = true;

export function getFormPdfSettings() {
  let saved = storageGet(KEY, null);
  if (!saved) {
    // One-off migration from the old un-namespaced key.
    try {
      const raw = window.localStorage.getItem(LEGACY_KEY);
      if (raw) { saved = JSON.parse(raw); storageSet(KEY, saved); window.localStorage.removeItem(LEGACY_KEY); }
    } catch { saved = null; }
  }
  return saved && typeof saved === 'object' ? { ...FORM_PDF_DEFAULTS, ...saved } : { ...FORM_PDF_DEFAULTS };
}

/** Save (merge) settings. Returns the merged settings, or throws if the browser refused to store them. */
export function saveFormPdfSettings(patch) {
  const next = { ...getFormPdfSettings(), ...patch };
  if (!storageSet(KEY, next)) throw new Error('This browser blocked saving the PDF settings (storage is full or disabled)');
  return next;
}

export default getFormPdfSettings;
